const TeamCard = ({ source, name, title, fb, twitter }) => {
  return (
    <div className="team-card">
      <div className="header">
        <div
          className="cover"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1549068106-b024baf5062d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80')",
          }}
        />
        <div className="content">
          <img className="avatar" src={source} alt={`${name}_avatar`} />
          <h1 className="fullname">{name}</h1>
          <h2 className="jobtitle">{title}</h2>
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
